import React, { useMemo } from 'react';
import { Button, Tooltip } from 'antd';
import { FileZipOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import useExport from '../../../../../hooks/comms/useExport';
import useMessageUser from '../../../../../hooks/useMessageUser';

interface DownloadDocumentsProps {
  selectedRows: any[];
}

const DownloadDocuments: React.FC<DownloadDocumentsProps> = ({ selectedRows }) => {
  const { exportZIP, downloading } = useExport();
  const { showMessage } = useMessageUser();
  const { t } = useTranslation();

  const validRows = useMemo(() => {
    const seen = new Set<number>();
    return selectedRows.filter(row => {
      if (seen.has(row.assId)) return false;
      seen.add(row.assId);
      return true;
    });
  }, [selectedRows]);

  const handleDownload = async () => {
    const ids = validRows.map(row => row.assId);
    try {
      await exportZIP('/comms/assigned/download_documents', { ids }, 'documentos');
    } catch (err: any) {
      showMessage(err?.message || t('downloadDocumentsError'), 'error');
    }
  };

  const disabled = validRows.length === 0;

  const tooltipTitle = disabled
    ? t('downloadDocumentsEmpty')
    : t('downloadDocumentsCount', { count: validRows.length });

  return (
    <Tooltip title={tooltipTitle}>
      <Button
        icon={<FileZipOutlined />}
        loading={downloading}
        disabled={disabled}
        onClick={handleDownload}
      />
    </Tooltip>
  );
};

export default DownloadDocuments;
